// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__17YM2","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3EPND","obliqueLine":"membershipbadge_obliqueLine__dU8J8"};